import { useTranslation } from '../../../lib/i18n';
import { useGenericBi } from '../../../lib/use-generic-bi';

export function StagedFileChips({ files, onRemove }: { files: File[]; onRemove: (index: number) => void }) {
  const { t } = useTranslation();
  const { logPageClickBi } = useGenericBi();
  if (files.length === 0) return null;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
      {files.map((f, i) => (
        <span
          key={`${f.name}-${i}`}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            paddingBlock: 5,
            paddingInlineEnd: 8,
            paddingInlineStart: 10,
            borderRadius: 'var(--sym-radius-badge)',
            background: 'rgba(var(--ink-rgb),0.05)',
            fontSize: 12.5,
            color: 'rgba(var(--ink-rgb),0.8)',
            maxWidth: 220,
          }}
        >
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.name}</span>
          <button
            type="button"
            aria-label={t('common.removeNamed', { name: f.name })}
            onClick={() => {
              logPageClickBi({ page_name: 'home', button_name: 'remove_attachment' });
              onRemove(i);
            }}
            style={{
              border: 'none',
              background: 'transparent',
              padding: 0,
              display: 'inline-flex',
              cursor: 'pointer',
              color: 'rgba(var(--ink-rgb),0.5)',
            }}
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden>
              <path d="M3 3l6 6M9 3l-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </button>
        </span>
      ))}
    </div>
  );
}
